<template>
  <v-container fluid>
  <v-dialog v-model="loadDialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Deletar</v-card-title>
      <v-card-text>Deseja excluir o Telefone?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#D32F2F" dark class="mr-2 text-capitalize" @click="deleteItem">Sim</v-btn>
        <v-btn color="#1DE9B6" outlined class="text-capitalize" @click="loadDialog = false">Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-card class='text-center'>
    <v-card-text>
      <ValidationObserver ref='observer' v-slot='{ passes  }'>
        <v-form>
          <v-container>
            <v-row justify="center">
              <v-col
                cols='12'
                md='6'
              >
                <ValidationProvider rules='required|min:3' name='Nome' v-slot='{ errors }'>
                  <v-text-field
                    v-model='entity.name'
                    :error-messages='errors'
                    label='Nome'
                    prepend-inner-icon='mdi-account-outline'
                    ref='initialFocus'
                    outlined
                    dense
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col
                cols='12'
                md='6'
              >
                <ValidationProvider rules='required|email' name='email' v-slot='{ errors }'>
                  <v-text-field
                    dense
                    v-model='entity.email'
                    :error-messages='errors'
                    label='E-mail'
                    prepend-inner-icon='mdi-email-outline'
                    outlined
                    required

                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols='12'
                md='6'
              >
                <ValidationProvider rules='required' name='initials' v-slot='{ errors  }'>
                  <v-text-field
                    v-model="entity.initials"
                    :error-messages='errors'
                    label="Sigla"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                cols='12'
                md='6'
              >
                <ValidationProvider  name='parent' v-slot='{ errors  }'>
                  <v-select
                    :items='entities'
                    v-model="parent"
                    :error-messages='errors'
                    label='Departamento Pai'
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row v-if="entity.id" class="text-center" justify="center">
              <v-col
                cols='12'
                md='12'
              >
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  :footer-props="{
                   showFirstLastPage: false,
                     'items-per-page-text':'linhas por página',
                     itemsPerPageOptions:[5,10,20,30,40,50]
                  }"
                  no-data-text="Nenhum registro disponível"
                  no-results-text="Nenhum registro encontrado"
                  sort-by="calories"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Telefones</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2 text-body-2"
                            v-bind="attrs"
                            v-on="on"
                          >Novo Telefone</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="6" md="6" lg="6">
                                  <v-text-field
                                    prepend-inner-icon='mdi-phone-outline'
                                   v-mask="['(##) ####-####', '(##) #####-####']"
                                   v-model="editedItem.number"
                                   label="Numero"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="primary darken-1" text @click="save">Salvar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="openConfirm(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-if="desserts.length != 0" v-slot:footer.page-text="props">
                    {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                cols='12'
                md='6'
              >
                <ValidationProvider rules='required'  name='number' v-slot='{ errors  }'>
                  <v-text-field
                    v-model="entity.number"
                    :error-messages='errors'
                    label='Telefone'
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    outlined
                    dense
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row class="text-right">
              <v-col
                cols='12'
                md='12'
              >
                <v-btn  :to="areaRoute" outlined class="mr-10"  color="primary">
                  Cancelar
                </v-btn>

                <v-btn black v-if="operation=='create'" class="mr-10" @click="passes(createSubmit)" color="primary">
                  Salvar
                </v-btn>

                <v-btn black v-else class="mr-10" @click="passes(updateSubmit)" color="primary">Atualizar</v-btn>
                <v-btn black outlined @click="clear" color="primary">Limpar</v-btn>
              </v-col>
            </v-row>
          </v-container>

        </v-form>
      </ValidationObserver>
    </v-card-text>

  </v-card>
  </v-container>
</template>

<script>
 import {ValidationObserver, ValidationProvider} from 'vee-validate';
 import areaRouteMixin from '@/mixins/area-route'
 import {getEntityId} from '@/graphql/queries/Entity.gql'
 import {mask} from 'vue-the-mask'
 import {apolloClient} from '@/vue-apollo'
 import { CreateMutation, UpdateMutation } from "@/graphql/mutations/Entity.gql";
 import notificationFormMixin from '@/mixins/notification-form'
 export default {
  name: "EntityForm2",
  directives: {
   mask
  },
  data () {
   return {
    accessedArea:'entities',
    entity: {},
    parent:'',
    loadDialog: false,
    dialog: false,
    headers: [
     {
      text: 'Telefones',
      align: 'start',
      sortable: true,
      value: 'number',
     },
     { text: 'Ações', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    itemDelete:null,
    editedItem: {},
    defaultItem: {
     number: '',
    },
   }
  },
  components: {
   ValidationObserver,
   ValidationProvider,
  },
  mixins: [
   areaRouteMixin,
   notificationFormMixin,
  ],
  watch: {
   dialog (val) {
    val || this.close()
   },
  },
  computed:{
   formTitle () {
    return this.editedIndex === -1 ? 'Novo Telefone' : 'Editar Telefone'
   },

   operation() {
    if (!this.$route.params.id) {
     return 'create'
    } else {
     return 'update'
    }
   },
   dataSubmit() {
    const data = {
     name: this.entity.name,
     initials: this.entity.initials,
     email:this.entity.email,
     parent: this.parent
    }
    return data;
   },
  },
  apollo: {
   entities: {
    query: require('@/graphql/queries/Entity.gql').getEntities,
    update: (data) => data.entities
   },
  },
  methods:{
   save () {
    this.$apollo.mutate({
     mutation: require('@/graphql/mutations/NumberEntity.gql').createMutationNumber,
     variables:{
      number : this.editedItem.number,
      entity: this.entity.id
     }
    }).then(()=>{
     if (this.editedIndex > -1) {
      Object.assign(this.desserts[this.editedIndex], this.editedItem)
     } else {
      this.desserts.push(this.editedItem)
     }
     this.close()
     this.$toasted.global.defaultSuccess();
    }).catch((erro) =>{
     console.error(erro)
    })
   },
   openConfirm(item) {
    this.loadDialog = true
    this.itemDelete = item

   },
   deleteItem(){
    this.$apollo.mutate({
     mutation: require('@/graphql/mutations/NumberEntity.gql').deletePhoneNumber,
     variables:{
      id : this.itemDelete.id,
     }
    }).then(()=>{
     this.$toasted.global.defaultSuccess();
     const index = this.desserts.indexOf(this.itemDelete)
     this.desserts.splice(index, 1)
     this.close()
    }).catch((erro) =>{
     console.error(erro)
    })
   },

   close () {
    this.dialog = false
    this.loadDialog = false
    this.editedItem={}
   },
   initialize () {
    this.desserts = []
   },
   createSubmit() {
    this.$apollo
      .mutate({
       mutation: CreateMutation,
       variables: {
        ...this.dataSubmit,
       },
      })
      .then(({data: {createEntity: {id}}}) => {
       this.$apollo.mutate({
        mutation: require('@/graphql/mutations/NumberEntity.gql').createMutationNumber,
        variables:{
         number : this.entity.number,
         entity: id
        }
       }).then(()=>{
        this.$toasted.global.defaultSuccess();
        this.$router.push(this.areaRoute)
       }).catch((erro) =>{
        console.error(erro)
       })
      })
      .catch(({graphQLErrors}) => {
       if (graphQLErrors[0].extensions.category === "graphql") {
        this.error = 'para adicionar logo clique em salvar logo!'
        this.$toasted.global.defaultError(this.error)
       } else if (graphQLErrors[0].extensions.category === "validation") {
        if (graphQLErrors[0].extensions.validation.alias) {
         this.error = graphQLErrors[0].extensions.validation.alias[0]
         this.$toasted.global.defaultError(this.error)
        } else if (graphQLErrors[0].extensions.validation.email) {
         this.error = graphQLErrors[0].extensions.validation.email[0]
         this.$toasted.global.defaultError(this.error)
         this.entity.email = null
        }
       }
      });
   },
   clear() {
    this.entity = {};
    this.parent = null
   },

   updateSubmit() {
    this.$apollo
      .mutate({
       mutation: UpdateMutation,
       variables: {
        id: this.entity.id,
        ...this.dataSubmit,
       },
      })
      .then(() => {
       this.$toasted.global.defaultSuccess();
       this.$router.push(this.areaRoute)
      })
      .catch((error) => {
       this.$toasted.global.defaultError({ error });
       console.error(error);
      });
   },
  },
  beforeRouteEnter(to, from, next) {
   if (to.params.id) {
    apolloClient.query({
     query: getEntityId,
     variables: {
      id: to.params.id
     },
     fetchPolicy: 'network-only'
    }).then(({data: {entity}}) => {
     if (entity) {
      next(vm => {
       vm.desserts = entity.phone_numbers
       vm.entity.id = entity.id
       vm.entity.name = entity.name
       vm.entity.email = entity.email
       vm.entity.initials = entity.initials
       vm.parent = entity.parent
      })
     }
    }).catch((error) => {
     console.error('Erro na Consulta', JSON.stringify(error.message))
    })
   } else {
    next()
   }
  },
  mounted() {
   this.setOnFocus('initialFocus')
  },
 }
</script>

<style scoped>

</style>